import React, {useEffect, useState} from 'react';
import UserRAPI from "../API/UserRAPI";
import TimeLineZP from "../components/UI/TimeLineZP";
import PaymentAdd from "../components/PaymentAdd";
import {useTitle} from "../hooks/useTitle";
import {useAccess} from "../hooks/useAccess";
import {useTypedSelector} from "../hooks/useTypedSelector";

const Units = () => {
    useTitle('Сотрудники')
    const roles = [
        {id: 1, name: 'Администраторы'},
        {id: 2, name: 'Мастера чистки'},
        {id: 3, name: 'Мастера ремонта'},
        {id: 4, name: 'Подрядчики'}
    ]

    const user = useTypedSelector(state => state.itemRefs.user)

    const [Year, SetYear] = useState(new Date().getFullYear())
    const [Month, SetMonth] = useState(new Date().getMonth() + 1)

    const hasAllZPAccess = useAccess('all_zp')

    const [Units, SetUnits] = useState([])
    const [Worker, SetWorker] = useState(hasAllZPAccess ? 0 : user.id)
    const [Stat, SetStat] = useState(null)
    const [Days, SetDays] = useState([])

    async function getList()
    {
        const res = await UserRAPI.GetList()

        SetUnits(res)
    }

    function getDays() {
        let arr = []

        if (Stat && Stat.stat && Stat.stat.dayStat) {
            Object.keys(Stat.stat.dayStat).sort().forEach(key => {
                arr.push({...Stat.stat.dayStat[key], day: key})
            });
        }

        return arr
    }

    async function setInfo()
    {
        const res = await UserRAPI.GetSalaryInfo(Worker, Year, Month)

        SetStat(res)
    }

    useEffect(function () {
        getList()
    }, [])

    useEffect(function () {
        setInfo()
    }, [Worker, Year, Month])

    useEffect(function () {
        SetDays(getDays())
    }, [Stat])

    const [modalPaymentAdd, setModalPaymentAdd] = useState(false)

    return (
        <div>
            <div className="card">

                <div className="card-header pb-0">
                    <div className="d-lg-flex">
                        <div>
                            <h4 className="mb-0">Сотрудники</h4>
                        </div>
                        <div className="w-100"/>
                        <select style={{display: 'inline-block'}} className="form-control w-auto" value={Year} onChange={(e) => SetYear(e.target.value)}>
                            <option value="2022">2022</option>
                            <option value="2023">2023</option>
                        </select>
                        <select style={{display: 'inline-block'}} className="form-control w-auto ms-3" value={Month} onChange={(e) => SetMonth(e.target.value)}>
                            <option value="1">Январь</option>
                            <option value="2">Февраль</option>
                            <option value="3">Март</option>
                            <option value="4">Апрель</option>
                            <option value="5">Май</option>
                            <option value="6">Июнь</option>
                            <option value="7">Июль</option>
                            <option value="8">Август</option>
                            <option value="9">Сентябрь</option>
                            <option value="10">Октябрь</option>
                            <option value="11">Ноябрь</option>
                            <option value="12">Декабрь</option>
                        </select>
                    </div>
                </div>
                <div className="card-body">
                    {hasAllZPAccess && roles.map((el) =>
                        <div>
                            <h6>{el.name}</h6>
                            {Units.hasOwnProperty(el.id) &&
                                <div style={{display: 'flex', gap: '0 20px', flexWrap: 'wrap'}}>
                                    {Units[el.id].map(v =>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="radio" id={'flexSwitchCheck_' + v.id} name="bubu" value={v.id} onChange={(e) => SetWorker(e.currentTarget.value)}/>
                                            <label className="form-check-label" htmlFor={'flexSwitchCheck_' + v.id}>{v.fio.replace(' ', '\u00A0')}</label>
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    )}

                    {Stat &&
                    <div className="d-grid d-md-block">
                        <h4 className="mt-3">{Stat.fio}</h4>
                        {Stat.stat &&
                        <>
                            <b><span className="ps-3 ps-md-0 text-secondary">Выручка:</span> {Intl.NumberFormat("ru").format(Stat.stat.total)}</b>
                            <b><span className="ps-3 text-secondary">Начислено:</span> {Intl.NumberFormat("ru").format(Stat.stat.accrued)}</b>
                            <b><span className="ps-3 text-secondary">Выдано:</span> {Intl.NumberFormat("ru").format(Stat.stat.accrued - Stat.stat.to_pay)}</b>
                            <b><span className="ps-3 text-secondary">К оплате:</span> {Intl.NumberFormat("ru").format(Stat.stat.to_pay)}</b>
                            {hasAllZPAccess &&
                            <button className="btn bg-gradient-info ms-4"
                                    onClick={() => setModalPaymentAdd(true)}>Выдать ЗП
                            </button>
                            }

                            <div className="row">
                                {Stat.stat.dayStat &&
                                <div className="col-md-9">
                                    <div className="row">
                                        {Days.map(el =>
                                            <div className="col-md-3 col-lg-2 col-sm-4 col-6">
                                                <div className="card mb-3">
                                                    <div className="card-body p-3">
                                                        <span>{el.day}</span>
                                                        <span className="float-end text-bold">{el.cnt}</span>
                                                        <br/>
                                                        <span
                                                            className="float-end text-bold">{Intl.NumberFormat("ru").format(el.summ)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                }
                                {Stat.payments && Stat.payments.length !== 0 &&
                                <div className="col-md-3">
                                    <h6 className="mb-3">История выдач</h6>
                                    <TimeLineZP timeline={Stat.payments}/>
                                </div>
                                }
                            </div>
                        </>
                        }
                    </div>
                    }
                </div>
            </div>
            {Stat &&
            <PaymentAdd hiddenComment={'ZP:'+Worker+':'+Year+':'+Month} payed={(sum) => {
                setInfo()
                setModalPaymentAdd(false)
            }} modal={modalPaymentAdd} closeModal={() => setModalPaymentAdd(false)}/>
            }
        </div>
    );
};

export default Units;